import { render, staticRenderFns } from "./SalesTax.vue?vue&type=template&id=62c1e17a"
import script from "./SalesTax.vue?vue&type=script&lang=js"
export * from "./SalesTax.vue?vue&type=script&lang=js"
import style0 from "./SalesTax.vue?vue&type=style&index=0&id=62c1e17a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports